const questionBlocks = document.querySelectorAll('[data-question-block]')

Array.prototype.forEach.call(questionBlocks, questionBlock => {
  const id = questionBlock.getAttribute('data-question-block')

  const tabList = questionBlock.querySelector('[data-question-block-list]')
  tabList.setAttribute('role', 'tablist')

  const tabs = questionBlock.querySelectorAll('[data-question-block-tab]')
  Array.prototype.forEach.call(tabs, (tab, i) => {
    tab.setAttribute('role', 'tab')
    tab.setAttribute('tabindex', '-1')
    tab.setAttribute('id', `tab-${id}-${ i + 1 }`)
    tab.parentNode.setAttribute('role', 'presentation')

    tab.addEventListener('click', event => {
      event.preventDefault()
      const currentTab = tabList.querySelector('[aria-selected]')

      if(event.currentTarget !== currentTab) {
        switchTab(panels, tabs, currentTab, event.currentTarget)
      }
    })

    tab.addEventListener('keydown', event => {
      const index = Array.prototype.indexOf.call(tabs, event.currentTarget)
      const dir = event.which === 37 ? index - 1 : event.which === 39 ? index + 1 : event.which === 40 ? 'down' : null

      if(dir !== null) {
        event.preventDefault()
        dir === 'down' ? panels[i].focus() : tabs[dir] ? switchTab(panels, tabs, event.currentTarget, tabs[dir]) : void 0;
      }
    })
  })

  const panels = questionBlock.querySelectorAll('[data-question-block-panel]')
  Array.prototype.forEach.call(panels, (panel, i) => {
    panel.setAttribute('aria-labelledby', tabs[i].id)
    panel.setAttribute('role', 'tabpanel')
    panel.setAttribute('tabindex', '-1')
    panel.hidden = true
  })

  tabs[0].removeAttribute('tabindex')

  const toggleButtons = questionBlock.querySelectorAll('[data-question-block-toggle')
  Array.prototype.forEach.call(toggleButtons, toggleButton => {
    const id = toggleButton.getAttribute(['data-question-block-toggle'])
    const answer = questionBlock.querySelector(`[data-question-block-answer="${id}"]`)
    answer.classList.add('is-hidden')
    toggleButton.setAttribute('aria-expanded', 'false')

    toggleButton.addEventListener('click', () => {
      answer.classList.toggle('is-hidden')

      if(toggleButton.getAttribute('aria-expanded') === 'true') {
        toggleButton.setAttribute('aria-expanded', 'false')
      } else {
        toggleButton.setAttribute('aria-expanded', 'true')
      }
    })
  })
})

function switchTab(panels, tabs, oldTab, newTab) {
  newTab.focus()
  newTab.removeAttribute('tabindex')
  newTab.setAttribute('aria-selected', 'true')

  if(oldTab) {
    oldTab.removeAttribute('aria-selected')
    oldTab.setAttribute('tabindex', '-1')
    let oldIndex = Array.prototype.indexOf.call(tabs, oldTab)
    panels[oldIndex].hidden = true
  }

  let index = Array.prototype.indexOf.call(tabs, newTab)
  panels[index].hidden = false
}
